import * as React from "react";
import * as cls from "./Footer.module.scss";
import { useSelector } from "react-redux";
import { StudentService } from "../../src/components/studentService/index.js";

export { Footer };
/**
 * Нижняя часть страницы с информацией об авторских правах.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Footer() {
  const [response, setResponse] = React.useState(null);
  const { vuzId } = useSelector((state) => state.contract);
  async function getFooter() {
    const request = {
      method: "get",
      path: "/brand/" + vuzId + "/footer",
    };
    const data = await StudentService.send(request, () => { });
    setResponse(data.footer);
  }
  React.useEffect(() => {
    if (vuzId) {
      getFooter();
    }
  }, [vuzId]);

  if (response)
    return (
      <footer className={cls.footer}>
        <p dangerouslySetInnerHTML={{ __html: response }}></p>
        {/* © Электронная информационно-образовательная среда (ЭИОС),
      <br />
      Цифровой образовательный ресурс «Личная студия», 2014-2024 */}
      </footer>
    );
}
